interface DeletedObject {
  deletedAt: string | null;
}

export const removeChecker = (obj: Partial<DeletedObject>) => !!obj.deletedAt;
